export default __webpack_public_path__ + "static/media/laptopbg.e56ecee8.jpeg";